export default {
  payWelfareText: 'Top-up Benefits',
  blackFridayDiscount: 'Black Friday Timed Discount',
  shareGift: 'Share Gift',
  vipWeeklyWelfare: 'VIP Weekly Discount',
  exchangeCoupon: 'Coupon',
  firstPayOff: 'Up to 15% OFF for 1st Purchase',
  blackFridayEvent: 'Black Friday Event',
  limitedTimeOff: 'Limited Time 10% OFF',
  claimCoupon: 'Claim Now',
  blackFridayTimedCoupon: 'Black Friday Timed Coupon',
  timeLeft: 'Time left: ',
  claimTimeCoupon: 'Claim 10% OFF Coupon Now!',
  points: 'Points: ${point}',
  costPointTip: 'Exchange points for coupons',
  maxPointTip: 'Each account my use up to 500 points.',
  discountOff: '10% OFF',
  highestDiscount: 'Up to ${discount} OFF',
  needPoint: 'Requires ${point} pts',
  changeCurrency: 'Change Currency',
  claim: 'Claim',
  claimSucc: 'Claimed',
  claimFail: 'Failed',
  pointNotEnough: 'Insufficient points',
  afterClaimPoint: 'Points left: ${point}',
  footTips1: 'Only 1 coupon can be used for each order.',
  footTips2: 'Coupon cannot be used for purchasing in-game currencies/tokens.',
  footTips3:
    ' We reserve the right for the final interpretation of this event.',
  ruleTitleText: 'Event Rules',
  ruleTime: 'Event Duration: 00:00 Nov.24, 2023 to 23:59 Nov. 26, 2023 (UTC)',
  bfRuleText1:
    '1. 400 points will be granted to your account when you log in to the official top-up page for the first time during the event. You may exchange up to 500 points for coupons.',
  bfRuleText2:
    '2. You may exchange Black Friday points for the coupons during the event.',
  bfRuleText3:
    '3. You may only use 1 coupon for each order. Coupons cannot be used for purchasing in-game currencies/tokens.',
  bfRuleText4: '4. For transactions, we only accept the following currencies:',
  ableCoinsType:
    'USD, JPY, KRW, TWD, EUR, HKD, GBP, CAD, AUD, RUB, MYR, THB, PLN, IDR.',
  bfRuleText5:
    '5. You may not change the currency once a transaction is made. Exchanged points cannot be refunded.',
  bfRuleText6: '6. Black Friday coupons will only be valid for 7 days.',
  bfRuleText7:
    '7. We reserve the right for the final interpretation of this event.',
  thanksTip:
    'Thank you for your participation. Please join our official community for more event information.',
  exchangePoints: 'Exchange',
  exchangeCode: 'Enter exchange code.',
  enterExchangeCode: 'Please enter exchange code.',
  exchangeText: 'Exchange',
  confirmGet: 'Confirm',
  couponUsedWay:
    'Coupon can only be used with specific currencies, please confirm your currency.',
  confirmText: 'Confirm',
  exchangeSucc: 'Exchanged',
  aboutCoins: 'About In-game Currencies/Tokens',
  aboutCoinsText:
    'You may exchange in-game currencies/tokens for all packs and privileges except for the in-game currency/token itself.',
  known: 'OK',
  codeText: 'Code',
  codeInvalid: 'Code invalid!',
  hasExchanged: 'You may not claim more codes.',
  hideText: 'Hide',
  //黑五的报错码
  'bf-20001': 'Not logged in',
  'bf-20002': 'Parameter error. Please try re-entering the event.',
  'bf-20003': 'Insufficient points',
  'bf-20004': 'Failed! Please try again later or contact Customer Support.',
  'bf-20005': 'Claimed',
  'bf-20015': 'The event is currently not available.',
  'bf-20016': 'The event has ended.',
  bfShareText: 'Claim 10% OFF Coupon Now!',
  rightsCenterBtn: 'Premium Member Center',
  payBtn: 'TOP UP',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Glorious Extraordinaire (Permanent)',
  '-': '-'
};
